<template>
    <v-app>
        <div>
            <v-container>
                <!-- <v-snackbar class="snakbar-sty pt-6 d-md-none pr-6 z-i6 rounded-pill"
                    transition="slide-x-reverse-transition" v-model="snackbar" timeout="4000" :value="true"
                    :color="snackbarclr" absolute text-color="white">
                    <v-icon class="mr-2" color="#fff">mdi-alert-outline</v-icon>
                    {{ snackmsgbar }}
                    <v-icon @click="snackbar = false" class="float-right" color="#fff">mdi-close-circle</v-icon>
                </v-snackbar> -->
                <v-snackbar  v-model="snackbar" timeout="4000" :value="true"
                    :color="snackbarclr" text-color="white">
                    <v-icon class="mr-2" color="#fff">mdi-alert-outline</v-icon>
                    {{ snackmsgbar }}
                    <v-icon @click="snackbar = false" class="float-right" color="#fff">mdi-close-circle</v-icon>
                </v-snackbar>
                <v-toolbar dense class="elevation-0 mb-4 mt-6 pr-4">
                    <v-toolbar-title>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="font-weight-bold headline">Ongoing new fund offerings</v-list-item-title>
                                <!-- <v-list-item-subtitle class="body-1 mb-0 mt-1" color="#878B93">
                  A summary of activity over a particular financial year.
                </v-list-item-subtitle> -->
                            </v-list-item-content>
                        </v-list-item>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <div class="mt-5 ml-4">
                    <v-card class="pb-5 overflow-hidden elevation-0 outlined" color="cardbg"
                        style="width: 80%; border: 1px solid #E0E0E0;">
                        <v-card class="elevation-0 pa-4" height="50" color="#F1F3F8">
                            <div class="d-flex">
                                <p class="font-weight-bold fs-16 maintext--text mb-0">
                                    NFO Fund
                                </p>
                            </div>
                        </v-card>

                        <div class="px-4 px-md-6 pt-4 pb-2">
                            <div v-if="mf_tenure == false">
                                <p class="font-weight-regular fs-14 subtext--text mt-3 mb-2">Client ID</p>
                                <v-autocomplete
                                    :placeholder="Errorplaceholder == 'Netword Error' ? Errorplaceholder : ''"
                                    :disabled="disabledmf" oninput="this.value = this.value.toUpperCase()" height="40px"
                                    background-color="#F1F3F8" flat class="rounded-pill" solo hide-details
                                    prepend-inner-icon="mdi-account-multiple-outline" v-model="mf_client_id"
                                    :items="clientcode" dense filled clearable label="Client Id" :loading="clientidload"
                                    :menu-props="{ contentClass: 'custom-dropdown' }"></v-autocomplete>

                                <p class="font-weight-regular mt-3 fs-14 subtext--text mb-2">Select Fund</p>
                                <v-autocomplete oninput="this.value = this.value.toUpperCase()"
                                    :placeholder="Errorplaceholder" :disabled="disabledmf" :loading="mflistloader"
                                    @change="autochange" height="40px" background-color="#F1F3F8" flat
                                    class="rounded-pill" solo hide-details hide-spin-buttons
                                    v-model="mf_invest_fund_name" :items="mf_data" item-text="name"
                                    prepend-inner-icon="mdi-magnify" clearable @click:clear="clearFundSelection">
                                    <template v-slot:item="data">
                                        <template>
                                            <v-list-item-content>
                                                <div>
                                                    <v-list-item-title
                                                        v-html="data.item.name"></v-list-item-title>
                                                                                  <v-list-item-subtitle class="mt-2">
         <v-chip color="secbg" class="table-hide" x-small text-color="subtext"
                      style="border-radius: 4px; padding: 10px 8px !important">
                      <span class="font-weight-medium fs-9">
                        {{ data.item.splito }}
                      </span>
                    </v-chip>
                    <v-chip color="secbg" class="table-hide mx-2" x-small text-color="subtext"
                      style="border-radius: 4px; padding: 10px 8px !important">
                      <span class="font-weight-medium fs-9">
                        {{ data.item.splitt ? data.item.splitt.replace("SCHEME", "") : "" }}
                      </span>
                    </v-chip>
        </v-list-item-subtitle>
                                                </div>
                                            </v-list-item-content>
                                        </template>
                                    </template>
                                </v-autocomplete>

                                <p class="font-weight-regular fs-14 subtext--text mt-3 mb-2">Investment amount</p>
                                <v-text-field :placeholder="Errorplaceholder == 'Netword Error' ? Errorplaceholder : ''"
                                    :disabled="disabledmf || !mf_invest_fund_name" height="40px"
                                    background-color="#F1F3F8" flat class="rounded-pill" solo type="number" hide-details
                                    hide-spin-buttons v-model="mf_invest_amt"
                                    :min="SelectedItem.Minimum_Purchase_Amount || 0"
                                    :step="SelectedItem.Minimum_Purchase_Amount || 1000">
                                    <template #append>
                                        <v-card v-if="SelectedItem.Minimum_Purchase_Amount"
                                            style="background-color: #F1F3F8;"
                                            @click="mf_invest_amt = Number(mf_invest_amt || 0) + Number(SelectedItem.Minimum_Purchase_Amount)"
                                            class="font-weight-bold subtitle-2 primary--text elevation-0 crd-trn">
                                            +{{ SelectedItem.Minimum_Purchase_Amount }}
                                        </v-card>
                                    </template>

                                    <template #prepend-inner>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="24"
                                            viewBox="0 0 24 24" fill="none">
                                            <path
                                                d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
                                                fill="white" />
                                            <path
                                                d="M15.4285 9.25426L15.0805 10.4574H8.58762L8.93066 9.25426H15.4285ZM12.3014 17L8.71689 12.6399L8.70197 11.7102H10.4818C10.9326 11.7102 11.3137 11.6423 11.6253 11.5064C11.9401 11.3705 12.1788 11.1716 12.3412 10.9098C12.5069 10.648 12.5898 10.3232 12.5898 9.93537C12.5898 9.36198 12.4191 8.90956 12.0777 8.57812C11.7363 8.24337 11.2043 8.07599 10.4818 8.07599H8.58762L8.94061 6.81818H10.4818C11.3005 6.81818 11.9733 6.95076 12.5003 7.21591C13.0306 7.47775 13.425 7.84067 13.6835 8.30469C13.942 8.7687 14.0713 9.29901 14.0713 9.8956C14.0713 10.4325 13.9603 10.9214 13.7382 11.3622C13.5194 11.7997 13.1698 12.156 12.6892 12.4311C12.2086 12.7029 11.5756 12.8537 10.79 12.8835L10.7453 12.8935L14.0365 16.9155V17H12.3014ZM15.4285 6.81818L15.0805 8.03125L9.91504 7.99645L10.2631 6.81818H15.4285Z"
                                                fill="#999999" />
                                        </svg>
                                    </template>
                                </v-text-field>

                                <p v-if="SelectedItem && SelectedItem.Minimum_Purchase_Amount"
                                    class="fs-10 subtext--text ml-6 mt-1">
                                    Min. ₹{{ SelectedItem.Minimum_Purchase_Amount }} (multiple of {{
                                        SelectedItem.Minimum_Purchase_Amount }})
                                </p>
                            </div>

                            <div v-else>
                                <!-- SIP/Tenure section (unchanged) -->
                            </div>

                            <v-toolbar class="tool-sty elevation-0 pt-4 mb-2 crd-trn" dense>
                                <span class="font-weight-regular caption subtext--text d-none d-md-block">
                                    <!-- AUM <span class="primary--text caption font-weight-bold"></span>
                                    {{ SelectedItem.AUM ? (SelectedItem.AUM / 10000000).toFixed(2) : '0.00' }}Cr. -->
                                    <br />
                                    NAV <span class="primary--text font-weight-bold">
                                        ₹{{ SelectedItem.NET_ASSET_VALUE || '0.00' }}
                                    </span>
                                </span>
                                <v-spacer></v-spacer>

                                <v-btn @click="sendorder" :loading="sumbitload" :disabled="checkfun() || SelectedItem.Purchase_Allowed != 'Y'"
                                    :color="buyvalue ? 'black' : 'red'"
                                    class="text-none rounded-pill elevation-0 white--text px-6 ml-4" height="40px">
                                    {{ buyvalue ? 'One-Time' : 'Sell' }}
                                </v-btn>
                                <v-btn @click="sipvalugetapis()"  :loading="siploadernew" :disabled="checkfun() || SelectedItem.SIP_FLAG != 'Y'"
                                    :color="buyvalue ? 'black' : 'red'"
                                    class="text-none rounded-pill elevation-0 white--text px-6 mr-4 ml-4" height="40px">
                                    SIP
                                </v-btn>

                            </v-toolbar>
                        </div>
                    </v-card>
                    <!-- <div class="d-flex">
                        <p class="mt-7 mb-4 title font-weight-bold">Punching Orders</p>
                        <div class="ml-auto mt-2 mr-8">
                            <div class="mt-4">
                                <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition"
                                    min-width="auto" class="mt-4">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field flat solo background-color="#F1F3F8" v-model="dateRangeText"
                                            prepend-inner-icon="mdi-calendar" readonly v-bind="attrs"
                                            class="rounded-pill" dense v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="dates" range @input="closeMenu"></v-date-picker>
                                </v-menu>
                            </div>
                        </div>
                        <div>
                            <v-text-field prepend-inner-icon="mdi-magnify" placeholder="Serach" height="40px" dense
                                background-color="#F1F3F8" flat class="rounded-pill mt-7 mr-8" solo hide-details
                                hide-spin-buttons v-model="searchval">

                            </v-text-field>
                        </div>

                    </div> -->
                    <!-- <v-divider ></v-divider>  -->

                    <!-- <template>
                        <v-data-table :search="searchval" style=" border: 1px solid #E0E0E0;" :items-per-page="100"
                            :headers="headers" :items="histroydata" :loading="hisloader" class="elevation-0"
                            fixed-header disable-sort>
                            <template v-slot:[`item.order_type`]="{ item }">
                                <p>{{ item.order_type == "NRM" ? "One-Time" : item.order_type == "XSP" ? "SIP" :
                                    item.order_type }}</p>
                            </template>
                            <template v-slot:[`item.butncheck`]="{ item }">
                                <v-btn v-if="item.local_status == 'PLACED'" :disabled="reinitload" class="text-none"
                                    @click="reinitiateapicall(item)" small dense elevation="0"
                                    color="primary">Re-generate Payment Link</v-btn>
                            </template>
                        </v-data-table>
                    </template> -->
                    <v-dialog persistent v-model="sipdiag" transition="dialog-bottom-transition" max-width="600">
                        <v-card class="pb-5 overflow-hidden" color="cardbg">
                            <v-card class="elevation-0 pa-4" color="#F1F3F8">
                                <div class="d-flex">
                                    <p class="font-weight-bold fs-16 maintext--text mb-0">
                                        {{ mf_invest_fund_name }}
                                    </p>
                                </div>
                            </v-card>
                            <div class="pa-5">
                                <p class="font-weight-regular fs-14 subtext--text mb-2">
                                    Mandates
                                    <v-tooltip top color="black">
                                        <template v-slot:activator="{ on, attrs }">
                                            <span v-bind="attrs" v-on="on">
                                                <svg v-if="mf_mandate && mf_mandate.Status == 'APPROVED'"
                                                    xmlns="http://www.w3.org/2000/svg" width="20" height="15"
                                                    viewBox="0 0 20 15" fill="none">
                                                    <rect width="20" height="15" rx="7" fill="#2DB266" />
                                                    <path d="M6.25 8.2475L8.415 10.4125L13.8275 5" stroke="white"
                                                        stroke-width="1.2" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                </svg>
                                                <svg v-else-if="mf_mandate && mf_mandate.Status"
                                                    xmlns="http://www.w3.org/2000/svg" width="20" height="15"
                                                    viewBox="0 0 20 15" fill="none">
                                                    <rect width="20" height="15" rx="7" fill="#DC2626" />
                                                    <path d="M7.5 10L12.5 5M7.5 5L12.5 10" stroke="white"
                                                        stroke-width="1.2" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                </svg>
                                            </span>
                                        </template>
                                        <span>{{ mf_mandate && mf_mandate.Status == "APPROVED" ? "Valid" : "Not valid"
                                        }}</span>
                                    </v-tooltip>
                                </p>

                                <!-- <div v-if="mf_mandates.length > 0"> -->
                                <v-select v-if="mf_mandates.length > 0" v-model="mf_mandate" :items="mf_mandates"
                                    append-icon="mdi-chevron-down" item-text="MandateId" item-value="MandateId"
                                    return-object background-color="#F1F3F8" flat class="rounded-pill mb-0" hide-details
                                    solo>
                                    <template v-slot:item="{ item, attrs, on }">
                                        <v-list-item v-on="on" v-bind="attrs">
                                            <!-- //:disabled="item.Status != 'APPROVED'" -->
                                            <v-list-item-content>
                                                <v-list-item-title class="font-weight-medium">{{ item.MandateId }}

                                                    <v-tooltip top color="black">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <span v-bind="attrs" v-on="on">
                                                                <svg v-if="item.Status == 'APPROVED'"
                                                                    xmlns="http://www.w3.org/2000/svg" width="20"
                                                                    height="15" viewBox="0 0 20 15" fill="none">
                                                                    <rect width="20" height="15" rx="7"
                                                                        fill="#2DB266" />
                                                                    <path d="M6.25 8.2475L8.415 10.4125L13.8275 5"
                                                                        stroke="white" stroke-width="1.2"
                                                                        stroke-linecap="round"
                                                                        stroke-linejoin="round" />
                                                                </svg>
                                                                <svg v-else-if="item.Status == 'REJECTED' || item.Status == 'INITIAL REJECTION' || item.Status.includes('REJECT')"
                                                                    xmlns="http://www.w3.org/2000/svg" width="20"
                                                                    height="15" viewBox="0 0 20 15" fill="none">
                                                                    <rect width="20" height="15" rx="7"
                                                                        fill="#DC2626" />
                                                                    <path d="M7.5 10L12.5 5M7.5 5L12.5 10"
                                                                        stroke="white" stroke-width="1.2"
                                                                        stroke-linecap="round"
                                                                        stroke-linejoin="round" />
                                                                </svg>
                                                                <svg v-else xmlns="http://www.w3.org/2000/svg"
                                                                    width="20" height="15" viewBox="0 0 20 15"
                                                                    fill="none">
                                                                    <rect width="20" height="15" rx="7"
                                                                        fill="#FFB038" />
                                                                    <path
                                                                        d="M5.3125 8.75C6.00286 8.75 6.5625 8.19036 6.5625 7.5C6.5625 6.80964 6.00286 6.25 5.3125 6.25C4.62214 6.25 4.0625 6.80964 4.0625 7.5C4.0625 8.19036 4.62214 8.75 5.3125 8.75Z"
                                                                        fill="white" />
                                                                    <path
                                                                        d="M10.3125 8.75C11.0029 8.75 11.5625 8.19036 11.5625 7.5C11.5625 6.80964 11.0029 6.25 10.3125 6.25C9.62214 6.25 9.0625 6.80964 9.0625 7.5C9.0625 8.19036 9.62214 8.75 10.3125 8.75Z"
                                                                        fill="white" />
                                                                    <path
                                                                        d="M15.3125 8.75C16.0029 8.75 16.5625 8.19036 16.5625 7.5C16.5625 6.80964 16.0029 6.25 15.3125 6.25C14.6221 6.25 14.0625 6.80964 14.0625 7.5C14.0625 8.19036 14.6221 8.75 15.3125 8.75Z"
                                                                        fill="white" />
                                                                </svg>
                                                            </span>
                                                        </template>
                                                        <span>{{ item.Status }}</span>
                                                    </v-tooltip>
                                                    <span class="float-right">{{ Number(item.Amount).toFixed(2)
                                                    }}</span>
                                                </v-list-item-title>
                                                <v-list-item-subtitle class="caption">reg date : {{ item.RegnDate }}
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                </v-select>
                                <p class="mb-0 sub-title-2 font-weight-bold" v-else>There are no mandates available, so
                                    please create one.
                                </p>

                                <p class="text-right mb-2"><v-btn
                                        @click="(sipdiag = false), (createmat = true), setDefaultmandate()"
                                        color="primary" small class="text-none font-weight-bold" text plain>+ Create
                                        mandate</v-btn></p>

                                        <!-- <div :class="mf_sipinit ? 'mb-2' : 'mb-4'">
                          <v-checkbox color="maintext" v-model="mf_sipinit" hide-details>
                            <template #label>
                              <p class="font-weight-regular fs-14 subtext--text mb-0">Pay initial investment now</p>
                            </template>
                          </v-checkbox>
                        </div> -->

                                <p class="font-weight-regular fs-14 subtext--text mb-2">Instalment amount</p>
                                <v-text-field height="40px" background-color="#F1F3F8" flat class="rounded-pill" solo
                                    type="number" hide-details hide-spin-buttons v-model="mf_instal_amt">
                                    <template #append>
                                        <v-card
                                            @click="mf_instal_amt += menudata.sipvalue[mf_frequency].SIP_MINIMUM_INSTALLMENT_AMOUNT"
                                            class="font-weight-bold subtitle-2 primary--text elevation-0 crd-trn">
                                            +
                                            {{ menudata.sipvalue[mf_frequency].SIP_MINIMUM_INSTALLMENT_AMOUNT }}
                                        </v-card>
                                    </template>

                                    <template #prepend-inner>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none">
                                            <path
                                                d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
                                                fill="white" />
                                            <path
                                                d="M15.4285 9.25426L15.0805 10.4574H8.58762L8.93066 9.25426H15.4285ZM12.3014 17L8.71689 12.6399L8.70197 11.7102H10.4818C10.9326 11.7102 11.3137 11.6423 11.6253 11.5064C11.9401 11.3705 12.1788 11.1716 12.3412 10.9098C12.5069 10.648 12.5898 10.3232 12.5898 9.93537C12.5898 9.36198 12.4191 8.90956 12.0777 8.57812C11.7363 8.24337 11.2043 8.07599 10.4818 8.07599H8.58762L8.94061 6.81818H10.4818C11.3005 6.81818 11.9733 6.95076 12.5003 7.21591C13.0306 7.47775 13.425 7.84067 13.6835 8.30469C13.942 8.7687 14.0713 9.29901 14.0713 9.8956C14.0713 10.4325 13.9603 10.9214 13.7382 11.3622C13.5194 11.7997 13.1698 12.156 12.6892 12.4311C12.2086 12.7029 11.5756 12.8537 10.79 12.8835L10.7453 12.8935L14.0365 16.9155V17H12.3014ZM15.4285 6.81818L15.0805 8.03125L9.91504 7.99645L10.2631 6.81818H15.4285Z"
                                                fill="#999999" />
                                        </svg>
                                    </template>
                                </v-text-field>
                                <p class="fs-10 subtext--text ml-6 mt-1">Min. ₹{{ menudata.sipvalue && mf_frequency ?
                                    menudata.sipvalue[mf_frequency].SIP_MINIMUM_INSTALLMENT_AMOUNT : 0.0 }} (multiple of
                                    1.0)</p>

                                <v-row class="pb-4">
                                    <v-col cols="8">
                                        <p class="font-weight-regular fs-14 subtext--text mb-2">Frequency</p>
                                        <v-select v-if="mf_frequency" v-model="mf_frequency"
                                            oninput="this.mf_frequency = mf_frequency.toUppercase()" hide-details
                                            :items="menudata.mf_frequencys" append-icon="mdi-chevron-down"
                                            background-color="#F1F3F8" flat class="rounded-pill" solo
                                            @change="(mf_instal_amt = menudata.sipvalue[mf_frequency].SIP_MINIMUM_INSTALLMENT_AMOUNT), (mf_noof_instal = menudata.sipvalue[mf_frequency].SIP_MINIMUM_INSTALLMENT_NUMBERS)">
                                        </v-select>
                                    </v-col>
                                    <v-col cols="4" class="pl-0">
                                        <p class="font-weight-regular fs-14 subtext--text mb-2">Date</p>
                                        <v-select v-if="mf_frequency"
                                            :disabled="menudata.sipvalue[mf_frequency].mf_dates.length <= 1"
                                            v-model="menudata.sipvalue[mf_frequency].mf_date" hide-details
                                            :items="menudata.sipvalue[mf_frequency].mf_dates"
                                            append-icon="mdi-chevron-down" background-color="#F1F3F8" flat
                                            class="rounded-pill" solo></v-select>


                                    </v-col>
                                </v-row>

                                <p class="font-weight-regular fs-14 subtext--text mb-2">
                                    Investment duration <span class="font-weight-bold txt-FF1 float-right">{{
                                        mf_noof_instal }} {{
                                            menudata.sipvalue && mf_frequency ? menudata.sipvalue[mf_frequency].freqis : ""
                                        }}</span>
                                </p>
                                <v-text-field v-if="mf_frequency" height="40px" background-color="#F1F3F8" flat
                                    class="rounded-pill mb-2" solo type="number" hide-details hide-spin-buttons
                                    :max="menudata.sipvalue[mf_frequency].SIP_MAXIMUM_INSTALLMENT_NUMBERS"
                                    :min="menudata.sipvalue[mf_frequency].SIP_MINIMUM_INSTALLMENT_NUMBERS"
                                    :step="menudata.sipvalue[mf_frequency].SIP_MINIMUM_INSTALLMENT_NUMBERS"
                                    v-model="mf_noof_instal">
                                </v-text-field>
                                <p class="fs-10 subtext--text ml-6 mt-1">Min. duration {{ menudata.sipvalue &&
                                    mf_frequency ?
                                    menudata.sipvalue[mf_frequency].SIP_MINIMUM_INSTALLMENT_NUMBERS : 0 }} {{
                                        menudata.sipvalue &&
                                            mf_frequency ? menudata.sipvalue[mf_frequency].freqis : "" }}</p>
                                <div>







                                    <p v-if="mf_tenure != null && menudata.types != 'redem'"
                                        class="font-weight-regular fs-12 subtext--text mb-0"><v-icon size="16"
                                            color="#666">mdi-information-outline</v-icon> NAV will be allotted on the
                                        day funds are realised
                                        at the clearing corporation.</p>


                                    <v-toolbar v-if="!menudata.payment && mf_tenure != null"
                                        class="tool-sty elevation-0 pt-4 mb-2 px-4 px-md-6 crd-trn" dense>
                                        <!-- <span  class="font-weight-regular fs-10 subtext--text d-none d-md-block">
                    AUM <span class="primary--text font-weight-bold">{{ (menudata.item.AUM / 10000000).toFixed(2) }}</span> Cr. <br />
                    NAV <span class="primary--text font-weight-bold">₹{{ Number(menudata.item.NET_ASSET_VALUE).toFixed(2) }}</span>
                  </span> -->
                                        <v-spacer></v-spacer>
                                        <v-btn :disabled="orderpoploader" @click="sipdiag = false" color="secbg"
                                            class="text-none rounded-pill elevation-0 subtext--text px-6" height="40px">
                                            Cancel </v-btn>
                                        <!-- (mf_mandate && mf_mandate.Status != 'APPROVED') || -->
                                        <v-btn @click="siporderapiflow()" :disabled="(mf_mandate && mf_mandate.Status != 'APPROVED') ||
                                            (mf_frequency && Number(mf_noof_instal) < menudata.sipvalue[mf_frequency].SIP_MINIMUM_INSTALLMENT_NUMBERS) ||
                                            (mf_frequency && Number(mf_instal_amt) < menudata.sipvalue[mf_frequency].SIP_MINIMUM_INSTALLMENT_AMOUNT)


                                            " :loading="orderpoploader" color="btnclr"
                                            class="text-none rounded-pill elevation-0 btntext--text px-6 ml-4"
                                            height="40px">
                                            SIP
                                        </v-btn>
                                        <!-- {{}} -->
                                    </v-toolbar>
                                </div>
                            </div>
                        </v-card>
                    </v-dialog>

                    <v-dialog persistent v-model="createmat" transition="dialog-bottom-transition" max-width="600">
                        <v-card class="pb-5 overflow-hidden" color="cardbg">
                            <v-card class="elevation-0 pa-4" color="#F1F3F8">
                                <div class="d-flex">
                                    <p class="font-weight-bold fs-16 maintext--text mb-0">
                                        Create mandate
                                    </p>
                                </div>
                            </v-card>

                            <div class="pa-4">
                                <p class="font-weight-regular fs-14 subtext--text mb-2">Amount *</p>
                                <v-text-field :readonly="orderpoploader" height="40px" background-color="#F1F3F8" flat
                                    class="rounded-pill mb-4" solo type="number" hide-details hide-spin-buttons
                                    @keyup="creatManmfamt ? (creatManmfamt = Number(creatManmfamt)) : creatManmfamt >= 100 ? mf_initial_amt : 100"
                                    :min="100" :step="1000" v-model="creatManmfamt">
                                    <template #append>
                                        <v-card @click="creatManmfamt += 1000"
                                            class="font-weight-bold subtitle-2 primary--text elevation-0 crd-trn">
                                            +
                                            {{ 1000 }}
                                        </v-card>
                                    </template>

                                    <template #prepend-inner>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none">
                                            <path
                                                d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
                                                fill="white" />
                                            <path
                                                d="M15.4285 9.25426L15.0805 10.4574H8.58762L8.93066 9.25426H15.4285ZM12.3014 17L8.71689 12.6399L8.70197 11.7102H10.4818C10.9326 11.7102 11.3137 11.6423 11.6253 11.5064C11.9401 11.3705 12.1788 11.1716 12.3412 10.9098C12.5069 10.648 12.5898 10.3232 12.5898 9.93537C12.5898 9.36198 12.4191 8.90956 12.0777 8.57812C11.7363 8.24337 11.2043 8.07599 10.4818 8.07599H8.58762L8.94061 6.81818H10.4818C11.3005 6.81818 11.9733 6.95076 12.5003 7.21591C13.0306 7.47775 13.425 7.84067 13.6835 8.30469C13.942 8.7687 14.0713 9.29901 14.0713 9.8956C14.0713 10.4325 13.9603 10.9214 13.7382 11.3622C13.5194 11.7997 13.1698 12.156 12.6892 12.4311C12.2086 12.7029 11.5756 12.8537 10.79 12.8835L10.7453 12.8935L14.0365 16.9155V17H12.3014ZM15.4285 6.81818L15.0805 8.03125L9.91504 7.99645L10.2631 6.81818H15.4285Z"
                                                fill="#999999" />
                                        </svg>
                                    </template>
                                </v-text-field>

                                <v-row no-glutters class="pb-4">
                                    <v-col cols="6">
                                        <p class="font-weight-regular fs-14 subtext--text mb-2">Start date *</p>

                                        <v-menu v-model="creatManmffrommenu" :close-on-content-click="false"
                                            transition="scale-transition" offset-y max-width="290px" min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field background-color="#F1F3F8" flat class="rounded-pill" solo
                                                    hide-details v-model="creatManmffrom" readonly v-bind="attrs"
                                                    v-on="on"></v-text-field>
                                            </template>
                                            <v-date-picker :readonly="orderpoploader"
                                                :min="new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 2).toISOString().slice(0, 10)"
                                                v-model="creatManmffrommodel" no-title
                                                @input="(creatManmffrommenu = false), (creatManmftomodel = new Date(new Date().getFullYear() + 30, new Date(creatManmffrommodel).getMonth(), new Date().getDate()).toISOString().slice(0, 10))"></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="6">
                                        <p class="font-weight-regular fs-14 subtext--text mb-2">End date *</p>
                                        <v-menu v-model="creatManmftomenu" :close-on-content-click="false"
                                            transition="scale-transition" offset-y max-width="290px" min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field background-color="#F1F3F8" flat class="rounded-pill" solo
                                                    hide-details v-model="creatManmfto" readonly v-bind="attrs"
                                                    v-on="on"></v-text-field>
                                            </template>
                                            <v-date-picker :readonly="orderpoploader"
                                                :min="creatManmffrommodel ? new Date(new Date().getFullYear(), new Date(creatManmffrommodel).getMonth() + 2, new Date().getDate()).toISOString().slice(0, 10) : new Date()"
                                                v-model="creatManmftomodel" no-title
                                                @input="creatManmftomenu = false"></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                </v-row>

                                <p class="font-weight-bold fs-14 mb-2">Remarks</p>
                                <v-text-field background-color="#F1F3F8" v-model="alertremarks" flat
                                    class="rounded-pill" solo dense type="text"> </v-text-field>
                            </div>

                            <div class="mx-4">
                                <v-row>
                                    <v-col cols="6">
                                        <v-btn block @click="createmat = false" color="#F1F3F8" :disabled="orderloader"
                                            class="text-none rounded-pill elevation-0 subtext--text px-6" height="40px">
                                            Cancel </v-btn>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-btn @click="createmandaute()" color="black" :loading="orderloader"
                                            :disabled="orderloader" block
                                            class="text-none rounded-pill elevation-0 white--text subtext--text px-6"
                                            height="40px"> Submit
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </div>



                        </v-card>
                    </v-dialog>
                    <!-- v-if="paymentlinkcard" -->
                    <v-card  v-if="paymentlinkcard"   outlined elevation="0" class="pa-5 mt-4"
                        style="width: 80%; border: 1px solid #E0E0E0;">
                        <div class="d-flex">
                            <p class=" title font-weight-bold">Re-generate Payment Link</p>
                            <div class="ml-auto">
                                <v-btn @click="urlcopfun()" icon><v-icon>mdi-content-copy</v-icon></v-btn>
                            </div>
                        </div>

                        <template>
                            <v-simple-table style=" border: 1px solid #E0E0E0;">
                                <template v-slot:default>

                                    <tbody outlined style=" border: 1px solid #E0E0E0;">
                                        <tr>


                                            <td>{{ reinipaylink && reinipaylink.clientcode ? reinipaylink.clientcode : 0
                                            }}</td>
                                           <td> <a :href="`${paymentres && paymentres.url ? paymentres.url : 0}`" target="_blank" ><b>{{  paymentres && paymentres.url ? paymentres.url : 0}}</b></a></td>

                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </template>
                    </v-card>

                </div>
            </v-container>
        </div>


    </v-app>
</template>

<script>
import axios from "axios";
import { apiurl } from "../apiUrl";
const today = new Date().toISOString().split("T")[0];
export default {
    data: () => ({
        dates: [today, today], // Default to today's date
        menu: false,
        appdialog: false,
        banndialog: false,
        signupbtn: false,
        mf_tenure: false,
        mf_invest_amt: '',
        bannerdata: [],
        formaname: "",
        mf_buyrsell: false,
        dialog: false,
        frommobile: "",
        formemail: "",
        mf_invest_fund_name: "",
        loader: false,
        mflistloader: false,
        mf_client_id: '',
        disabledmf: false,
        valid: true,
        signupValue: "",
        pathurl: "",
        snackbar: false,
        snackbarclr: "#000",
        snackmsgbar: "",
        Errorplaceholder: 'Search here More then 2 Letter EX: REL',
        buyvalue: true,
        bannercondition: "",
        mf_data: [],
        SelectedItem: {
            Minimum_Purchase_Amount: 0,
            NET_ASSET_VALUE: 0,
            AUM: 0,
            Scheme_Code: ''
        },
        clientcode: [],
        clientidload: true,
        searchTimeout: null,
        clientCode: "",
        headers: [
        { text: 'Order Number', value: 'order_number' },

            {
                text: 'Date Time',
                align: 'start',
                sortable: false,
                value: 'date_time',
            },
            { text: 'Client Code', value: 'clientcode' },
            { text: 'Fund Name', value: 'scheme_name' },
            { text: 'ISIN', value: 'isin' },
            { text: 'Order Type', value: 'order_type' },
            { text: 'Amount', value: 'lumpsum_amount' },
            { text: 'Status', value: 'local_status' },
            { text: 'Placed by', value: 'placed_by' },

            { text: '', value: 'butncheck' },
        ],
        hisloader: true,
        histroydata: [],
        sumbitload: false,
        searchval: "",
        sipdiag: false,
        mf_mandates: [],
        mf_mandate: null,
        createmat: false,
        creatManmfamt: 1000,
        creatManmffrommodel: "",
        creatManmffrommenu: false,

        creatManmftomodel: "",
        creatManmftomenu: false,
        creatManmRemarks: "",
        orderpoploader: false,
        orderloader: false,
        alertremarks: "",
        // mf_frequencys: [],
        // mf_mandates: [],
        mf_frequencys: [],
        mf_dates: false,
        mf_frequency: null,
        // mf_mandate: "",
        mf_date: "",
        // mf_invest_amt: 1000,
        mf_initial_amt: 1000,
        mf_instal_amt: 1000,
        // mf_tenure: false,
        mf_sipinit: false,
        mf_noof_instal: 0,
        mf_redqty: 0,

        mfpayinmode: null,
        mfpayinmodes: [
            { key: "UPI", val: "UPI" },
            { key: "NET BANKING", val: "Net banking" },
            // {key: "NIFT", val: "NIFT"},
        ],
        mfpainids: null,
        mf_accact: null,
        mfupivalid: true,
        menudata: {},
        upiidfield: false,
        siploadernew: false,
        paymentlinkcard: false,
        paymentres:[],
        reinitload:false,
    }),

    mounted() {
        this.mfdialogue();
        this.clientcodeget();
        // this.historeydata()
        this.clientCode = localStorage.getItem("brcode")
        // this.mandategetapi()
        // this.setDefaultmandate();
    },

    methods: {
        // setmfUpiValid() {
        //     console.log("this.mfpayinmode", this.mfpayinmode);
        //     if (this.mfpayinmode == "UPI") {
        //         if (this.$refs.mfupiform.validate()) {
        //             this.orderpoploader = true;
        //             const axios = require('axios');
        //             let data = JSON.stringify({
        //                 "VPA": this.mfpainids,
        //                 "clientID": "123456789",
        //                 "bank_acc": "123456789"
        //             });

        //             let config = {
        //                 method: 'post',
        //                 maxBodyLength: Infinity,
        //                 url: 'https://fundapi.mynt.in/hdfc/upi/checkClientVPA',
        //                 headers: {
        //                     'authorization': 'e75bcf137962162706cb02974a6ed3b34b6545f6bd5387e5fd79d29e9d28caf1',
        //                     'clientid': 'Z51875',
        //                     'Content-Type': 'application/json'
        //                 },
        //                 data: data
        //             };

        //             axios.request(config)
        //                 .then((response) => {
        //                     // console.log(JSON.stringify(response.data));
        //                     let data = response.data
        //                     if (data.data.verified_VPA_status1 == "Available") {
        //                         // this.setMForder();
        //                         console.log("iss working");
        //                         this.siporderapiflow();
        //                     } else {
        //                         this.upiidfield = true;

        //                         // this.snackAlert(2, 'Invalid UPI ID')
        //                         this.orderpoploader = false;
        //                     }
        //                 })
        //                 .catch((error) => {
        //                     console.log(error);
        //                     this.snackbar = true;
        //             this.snackbarclr = "red";
        //             this.snackmsgbar = 'Network Error';
        //                 });

        //             //   let data = await getUpivpa([this.mfpainids, this.uid, this.token]);

        //         }
        //     } else {
        //         console.log("nettt");
        //         this.siporderapiflow()
        //     }
        // },

        reinitiateapicall(item) {
            this.reinitload = item.order_number
            console.log(item);
            this.reinipaylink = item
            const axios = require('axios');
            let data = JSON.stringify({
                "client_code": item.clientcode,
                "order_number": item.order_number
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mf/order_status_checking',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    console.log(JSON.stringify(response.data));
                    if (response.data.stat == "Ok") {
                        if (response.data.server_resp == "100|PAYMENT NOT INITIATED FOR GIVEN ORDER") {
                            axiosThis.snackbar = true;
                            axiosThis.snackbarclr = "green";
                            axiosThis.snackmsgbar = "Payment Link Generated";
                            axiosThis.paymentlinkgen(item.clientcode)
                        } else {
            axiosThis.reinitload = false
                            axiosThis.snackbar = true;
                            axiosThis.snackbarclr = "orange";
                            axiosThis.snackmsgbar = response.data.server_resp;
                        }
                    } else {
                        axiosThis.snackbar = true;
                        axiosThis.snackbarclr = "red";
                        axiosThis.snackmsgbar = response.data;
            axiosThis.reinitload = false

                    }
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.snackbar = true;
                    axiosThis.snackbarclr = "red";
                    axiosThis.snackmsgbar = error;
            axiosThis.reinitload = false

                });


        },

        paymentlinkgen(ccode) {
            this.reinitload = true
            this.paymentres = []
            const axios = require('axios');
            let data = JSON.stringify({
                "client_code": ccode
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mf/payment_gateway_link',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    // console.log(JSON.stringify(response.data));
            axiosThis.reinitload = false
                    if (response.data.stat == 'Ok') {
                        axiosThis.paymentres = response.data
                        axiosThis.paymentlinkcard = true
                        // axiosThis.snackbar = true;
                        // axiosThis.snackbarclr = "green";
                        // axiosThis.snackmsgbar = response.data;
                        // window.open(`${response.data.url}`, '_blank');
                    } else {
                        axiosThis.snackbar = true;
                        axiosThis.snackbarclr = "green";
                        axiosThis.snackmsgbar = response.data;
                    }

                })
                // 
                .catch((error) => {
                    console.log(error);
                    axiosThis.snackbar = true;
                    axiosThis.snackbarclr = "red";
                    axiosThis.snackmsgbar = error
            axiosThis.reinitload = false

                });

        },

        urlcopfun() {

            const url = this.paymentres.url;
            navigator.clipboard.writeText(url)
                .then(() => {
                    this.snackbar = true;
                    this.snackbarclr = "green";
                    this.snackmsgbar = "URL copied to clipboard!"
                    console.log('URL copied to clipboard!');
                    // You can also show a toast or snackbar here
                })
                .catch((err) => {
                    console.error('Failed to copy:', err);
                    this.snackbar = true;
                    this.snackbarclr = "red";
                    this.snackmsgbar = "Failed to copy Url"
                });


        },

      siporderapiflow() {
            this.orderpoploader = true;
            let clientCode11 = localStorage.getItem("brcode");

            const axios = require('axios');
            let data = JSON.stringify({
                "ClientCode": this.mf_client_id,
                "no_of_installment": String(this.mf_noof_instal),
                "scheme_code": this.SelectedItem?.Scheme_Code,
                "freq_type": this.mf_frequency.toUpperCase(),
                "installment_amt": String(this.mf_instal_amt),
                "mandate_id": this.mf_mandate.MandateId,
                "start_date": this.menudata.sipvalue[this.mf_frequency].mf_date,
                "isin": this.SelectedItem?.ISIN,
                "placed_by": clientCode11,
                 "source":`Branch dasboard - ${localStorage.getItem("email")}`,
                // "first_order":this.mf_sipinit == true ? 'Y' : 'N'

            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mfapi/order/xsip_purchase',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    console.log(JSON.stringify(response.data));
                    if (response.data.stat == "Ok") {
                        axiosThis.snackbar = true;
                        axiosThis.snackbarclr = "green";
                        axiosThis.snackmsgbar = response.data.Remarks;
                        axiosThis.historeydata()
                        axiosThis.clearFundSelection()
                        axiosThis.mf_sipinit = false
                    } else {
                        axiosThis.snackbar = true;
                        axiosThis.snackbarclr = "red";
                        axiosThis.snackmsgbar = response.data;
                    }
                    axiosThis.sipdiag = false
                    axiosThis.orderpoploader = false;
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.sipdiag = false
                    axiosThis.orderpoploader = false;
                    axiosThis.snackbar = true;
                    axiosThis.snackbarclr = "red";
                    axiosThis.snackmsgbar = 'Network Error';
                });

        },

        networkerror() {
            this.snackbar = true;
            this.snackbarclr = "red";
            this.snackmsgbar = 'Network Error';
            this.sumbitload = false
        },
        setDefaultmandate() {
            this.creatManmffrommodel = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1).toISOString().slice(0, 10);
            this.creatManmftomodel = new Date(new Date().getFullYear() + 30, new Date(this.creatManmffrommodel).getMonth(), new Date().getDate()).toISOString().slice(0, 10);
        },
        createmandaute() {
            this.orderloader = true
            const axios = require('axios');
            let data = JSON.stringify({
                "client_code": this.mf_client_id,
                "amount": String(this.creatManmfamt),
                "startdate": this.creatManmffrom,
                "enddate": this.creatManmfto
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mfapi/order/mandate_creation',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    // console.log(JSON.stringify(response.data));
                    axiosThis.createmat = false
                    this.orderloader = false
                    if (response.data.stat == "Ok") {
                        axiosThis.snackbar = true;
                        axiosThis.snackbarclr = "green";
                        axiosThis.snackmsgbar = 'MANDATE REGISTRATION DONE SUCCESSFULLY';
                    } else {
                        axiosThis.snackbar = true;
                        axiosThis.snackbarclr = "red";
                        axiosThis.snackmsgbar = response.data;
                    }
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.createmat = false
                    this.orderloader = false
                    axiosThis.snackbar = true;
                    axiosThis.snackbarclr = "red";
                    axiosThis.snackmsgbar = 'Network Error';
                });

        },
        sipvalugetapis() {
            this.siploadernew = true
            this.sipvaluesget()
            this.mandategetapi()
            // this.clibankdet()
            // this.clientupiid()
            // this.siploadernew = false
            this.sipdiag = true

        },
        sipvaluesget() {
            this.siploadernew = true
            let data = JSON.stringify({
                "isin": this.SelectedItem?.ISIN || "",
                "scheme_code": this.SelectedItem?.Scheme_Code || ""
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mfapi/order/sip_values',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };

            axios.request(config)
                .then((response) => {
                    let sipvalue = response.data
                    if (sipvalue.stat == "Ok") {
                        this.menudata["sipvalue"] = {};
                        this.menudata["mf_frequencys"] = [];
                        for (let i = 0; i < sipvalue.data.length; i++) {
                            let freq = sipvalue.data[i].SIP_FREQUENCY.slice(0, 1) + sipvalue.data[i].SIP_FREQUENCY.slice(1, sipvalue.data[i].SIP_FREQUENCY.length).toLocaleLowerCase();
                            this.menudata.mf_frequencys.push(freq);
                            this.menudata.sipvalue[freq] = sipvalue.data[i];
                            this.menudata.sipvalue[freq]["mf_dates"] = sipvalue.data[i].SIP_DATES ? sipvalue.data[i].SIP_DATES.split(",") : ["0"];
                            this.menudata.sipvalue[freq]["mf_date"] = this.menudata.sipvalue[freq]["mf_dates"][0];
                            this.menudata.sipvalue[freq]["freqis"] = freq == "Daily" ? "Days" : freq == "Monthly" ? "Months" : freq == "Quarterly" ? "Qtrs" : freq;

                            this.menudata.sipvalue[freq]["SIP_INSTALLMENT_GAP"] = this.menudata.sipvalue[freq]["SIP_INSTALLMENT_GAP"] ? Number(this.menudata.sipvalue[freq]["SIP_INSTALLMENT_GAP"]) : "";
                            this.menudata.sipvalue[freq]["SIP_MINIMUM_GAP"] = this.menudata.sipvalue[freq]["SIP_MINIMUM_GAP"] ? Number(this.menudata.sipvalue[freq]["SIP_MINIMUM_GAP"]) : "";
                            this.menudata.sipvalue[freq]["SIP_MAXIMUM_GAP"] = this.menudata.sipvalue[freq]["SIP_MAXIMUM_GAP"] ? Number(this.menudata.sipvalue[freq]["SIP_MAXIMUM_GAP"]) : "";
                            this.menudata.sipvalue[freq]["SIP_MINIMUM_INSTALLMENT_AMOUNT"] = this.menudata.sipvalue[freq]["SIP_MINIMUM_INSTALLMENT_AMOUNT"] ? Number(this.menudata.sipvalue[freq]["SIP_MINIMUM_INSTALLMENT_AMOUNT"]) : "";
                            this.menudata.sipvalue[freq]["SIP_MAXIMUM_INSTALLMENT_AMOUNT"] = this.menudata.sipvalue[freq]["SIP_MAXIMUM_INSTALLMENT_AMOUNT"] ? Number(this.menudata.sipvalue[freq]["SIP_MAXIMUM_INSTALLMENT_AMOUNT"]) : "";
                            this.menudata.sipvalue[freq]["SIP_MINIMUM_INSTALLMENT_NUMBERS"] = this.menudata.sipvalue[freq]["SIP_MINIMUM_INSTALLMENT_NUMBERS"] ? Number(this.menudata.sipvalue[freq]["SIP_MINIMUM_INSTALLMENT_NUMBERS"]) : "";
                            this.menudata.sipvalue[freq]["SIP_MAXIMUM_INSTALLMENT_NUMBERS"] = this.menudata.sipvalue[freq]["SIP_MAXIMUM_INSTALLMENT_NUMBERS"] ? Number(this.menudata.sipvalue[freq]["SIP_MAXIMUM_INSTALLMENT_NUMBERS"]) : "";
                            this.menudata.sipvalue[freq]["SIP_MULTIPLIER_AMOUNT"] = this.menudata.sipvalue[freq]["SIP_MULTIPLIER_AMOUNT"] ? Number(this.menudata.sipvalue[freq]["SIP_MULTIPLIER_AMOUNT"]) : "";
                        }
                        //   this.getMFmandata();
                        this.mf_frequency = this.menudata.mf_frequencys[0];
                        this.mf_instal_amt = this.menudata.sipvalue[this.mf_frequency].SIP_MINIMUM_INSTALLMENT_AMOUNT;
                        this.mf_noof_instal = this.menudata.sipvalue[this.mf_frequency].SIP_MINIMUM_INSTALLMENT_NUMBERS;
                        //   this.setDefaultmandate();
                    } else {
                        this.snackbar = true;
                        this.siploadernew = false
                        this.snackbarclr = "red";
                        this.snackmsgbar = 'Network Error';
                    }
                })
                .catch((error) => {
                    console.error("API Request Failed:", error);
                    this.snackbar = true;
                    this.snackbarclr = "red";
                    this.snackmsgbar = 'Network Error';
                });
        },
        mandategetapi() {
            // this.sumbitload = true
            this.siploadernew = true
            const axios = require('axios');
            let data = JSON.stringify({
                // "client_code": this.mf_client_id,
                "client_code": this.mf_client_id,
                "mandate_id": ""
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in//mfapi/order/mandate_details',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {

                    axiosThis.siploadernew = false
                    // console.log(JSON.stringify(response.data));
                    if (response.data.stat == "Ok") {
                        axiosThis.mf_mandates = response.data.data.MandateDetails;
                        // console.log("lklk",axiosThis.mf_mandates);

                        axiosThis.mf_mandate = response.data.data.MandateDetails[0];
                    }

                    if (response.data.stat != "Ok" && response.data.error != 'Mandate Details Not Found') {
                        axiosThis.snackbar = true;
                        axiosThis.snackbarclr = "red";
                        axiosThis.snackmsgbar = response.data.error;
                        axiosThis.siploadernew = false
                    }

                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.networkerror()
                    axiosThis.siploadernew = false
                });

        },
        clibankdet() {
            this.siploadernew = true
            const axios = require('axios');
            let data = JSON.stringify({
                "client_code": this.mf_client_id,
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mfapi/order/client_bank_details',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    // console.log(JSON.stringify(response.data));
                    axiosThis.siploadernew = false

                    axiosThis.menudata.mf_bankaccs = response.data.data;
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.siploadernew = false
                    axiosThis.networkerror()

                });

        },

        clientupiid() {
            const axios = require('axios');
            let data = JSON.stringify({
                "client_id": this.mf_client_id,
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://fundapi.mynt.in/withdraw/view_upi_id',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    // console.log(JSON.stringify(response.data));
                    let upis = response.data
                    console.log("ststst", upis)
                    console.log("ststst", upis.stat)
                    console.log("ststst", upis.data[0])

                        ;

                    if (upis.stat == "Ok" && upis.data[0] && upis.data[0].upi_id && upis.data[0].client_id == this.mf_client_id) {
                        axiosThis.mfpainids = upis.data[0].upi_id;
                        console.log("ifif", axiosThis.mfpainids);

                    } else {
                        axiosThis.mfpainids = null;
                        console.log("elseee", axiosThis.mfpainids);

                    }

                })
                .catch((error) => {
                    console.log(error);
                });

        },

        closeMenu() {
            if (this.dates.length === 2) {
                console.log("Selected Dates:", this.dates);
                this.historeydata()
                this.menu = false; // Close date picker after selection
            }
        },
        historeydata() {
            console.log("rrr", this.dateRangeText);
            this.paymentlinkcard = false

            this.histroydata = []
            this.hisloader = true
            let clientCode11 = localStorage.getItem("brcode");
            const axios = require('axios');
            let data = JSON.stringify({
                "placed_by": clientCode11,
                "from_date": this.dates[0],
                "to_date": this.dates[1],
                  "type": localStorage.getItem("mode")
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                // url: 'http://192.168.5.175:5008/history_orders_aprm',
                url: 'https://v3.mynt.in/mf/history_orders_aprm',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    // console.log(JSON.stringify(response.data));
                    axiosThis.hisloader = false
                    axiosThis.histroydata = response.data.data
                    if (response.data.stat != 'Ok') {
                        axiosThis.snackbar = true;
                        axiosThis.snackbarclr = "red";
                        axiosThis.snackmsgbar = response.data;
                    }

                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.hisloader = false
                    axiosThis.snackbar = true;
                    axiosThis.snackbarclr = "red";
                    axiosThis.snackmsgbar = error;

                });

        },
        clearFundSelection() {
            this.SelectedItem = {
                Minimum_Purchase_Amount: 0,
                NET_ASSET_VALUE: 0,
                AUM: 0,
                Scheme_Code: ''
            };
            this.mf_invest_amt = '';
            this.mf_client_id = "";
            this.mf_invest_fund_name = ""

        },

        clientcodeget() {
            // console.log("gydvdv",this.clientCode);
            let clientCode11 = localStorage.getItem("brcode");
            console.log("!!!", clientCode11);

            this.clientidload = true;
            this.clientcode = [];
            const axios = require('axios');
            let data = JSON.stringify({
                "code": clientCode11,
                "type": localStorage.getItem("mode")
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${apiurl}/client_list_branch`,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this;

            axios.request(config)
                .then((response) => {
                    axiosThis.clientcode = response.data.client_id;
                    axiosThis.clientidload = false;
                    if (response.data.stat == "Ok") {
                        // for (let i = 0; i < axiosThis.clientcode.length; i++) {
                        //         console.log("test",axiosThis.clientcode[i]);
                        //         }

                    } else {
                        axiosThis.snackbar = true;
                        axiosThis.snackbarclr = "red";
                        axiosThis.snackmsgbar = response.data;
                    }
                })
                .catch((error) => {
                    axiosThis.clientidload = false;
                    console.log(error);
                    axiosThis.snackbar = true;
                    axiosThis.snackbarclr = "red";
                    axiosThis.snackmsgbar = 'Network Error';
                });
        },

        checkfun() {
            return (
                (this.SelectedItem && this.SelectedItem.Minimum_Purchase_Amount
                    ? Number(this.mf_invest_amt || 0) < this.SelectedItem.Minimum_Purchase_Amount
                    : true) ||
                this.mf_invest_amt === '' ||
                this.mf_client_id.length < 4 ||
                this.mf_invest_fund_name === ''
            );
        },

        autochange(item) {
            if (item) {
                this.SelectedItem = this.mf_data.find(element => element.name === item);
                this.mf_invest_amt = this.SelectedItem.Minimum_Purchase_Amount;

                console.log("111", this.SelectedItem.ISIN);

            } else {
                this.clearFundSelection();
            }
        },


      sendorder() {
            this.sumbitload = true
            let clientCode11 = localStorage.getItem("brcode");
            console.log(clientCode11, this.mf_client_id, this.SelectedItem.Scheme_Code, this.SelectedItem.ISIN, this.mf_invest_amt);
            if (this.mf_client_id != "" && this.mf_client_id != null) {
                console.log("inin");

                let data = JSON.stringify({
                    "ClientCode": this.mf_client_id,
                    "scheme_code": this.SelectedItem.Scheme_Code,
                    "source": `Branch Dasboard - ${localStorage.getItem("email")}`,
                    "amount": this.mf_invest_amt,
                    "placed_by": clientCode11,
                });

                let config = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    url: 'https://v3.mynt.in/mfapi/order/PlaceLumpsumOrder',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: data
                };
                let axiosThis = this;
                axios.request(config)
                    .then((response) => {
                        // console.log(JSON.stringify(response.data));
                        axiosThis.sumbitload = false
                        if (response.data.stat == 'Ok') {
                            axiosThis.historeydata()
                            axiosThis.clearFundSelection()
                            axiosThis.snackbar = true;
                            axiosThis.snackbarclr = "green";
                            axiosThis.snackmsgbar = response.data.Remarks;
                            axiosThis.dialog = false;
                        } else {
                            axiosThis.snackbar = true;
                            axiosThis.snackbarclr = "red";
                            axiosThis.snackmsgbar = response.data;
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        axiosThis.snackbar = true;
                        axiosThis.snackbarclr = "red";
                        axiosThis.snackmsgbar = 'Network Error';
                        axiosThis.sumbitload = false

                    });
            } else {
                console.log("elseeee");

                this.snackbar = true;
                this.snackbarclr = "red";
                this.snackmsgbar = 'Network Error';
                this.sumbitload = false

            }
        },

       mfdialogue() {
            this.snackmsgbar = ""

            const url = new URL(window.location.href);
            console.log(url);

            this.dialog = true;
            this.mflistloader = true;
            this.disabledmf = true;
            console.log("yes its coming");
           const axios = require('axios');
         

          let config = {
  method: 'post',
  maxBodyLength: Infinity,
  url: 'https://v3.mynt.in/mfapi/dashboard/NFO_datas',
  headers: { }
};
            let axiosThis = this;
            axios.request(config)
                .then((response) => {
                    // if (response.data.stat == 'Ok') {

                    var showdata = response.data.data;
for (let w = 0; w < showdata.length; w++) {
  let arr = showdata[w].Scheme_Name.split("-");

  // Default
  let type = "NORMAL";

  if (arr.some(a => a.includes("GROWTH"))) type = "GROWTH";
  else if (arr.some(a => a.includes("IDCW PAYOUT"))) type = "IDCW PAYOUT";
  else if (arr.some(a => a.includes("IDCW REINVESTMENT"))) type = "IDCW REINVESTMENT";
  else if (arr.some(a => a.includes("IDCW"))) type = "IDCW";

  showdata[w]["splito"] = type;
  showdata[w]["splitt"] = showdata[w].Scheme_Type.toUpperCase();
}

axiosThis.mf_data = showdata;
console.log("axiosThis.mf_data", axiosThis.mf_data);

                        // axiosThis.mf_data = response.data.data;
                        axiosThis.mflistloader = false;
                        axiosThis.disabledmf = false;
                        // console.log(axiosThis.mf_data);
                    // } else {
                    //     axiosThis.mflistloader = false;
                    //     axiosThis.disabledmf = true;
                    //     axiosThis.Errorplaceholder = 'Funds not available';
                    // }
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.mflistloader = false;
                    axiosThis.Errorplaceholder = "Network Error";
                    axiosThis.disabledmf = true;
                    axiosThis.snackbar = true;
                    axiosThis.snackbarclr = "red";
                    axiosThis.snackmsgbar = 'Network Error';
                });
        },

        mfsearch(val) {
            clearTimeout(this.searchTimeout);

            // Set a new timeout to wait until user stops typing
            this.searchTimeout = setTimeout(() => {
                this.fetchmfsearch(val); // Call the API or perform the search
            }, 500); // Wait for 500ms after the last keypress 
        },

        fetchmfsearch(val) {
            console.log();

            if (val && val.length > 2) {
                this.mflistloader = true;
                let data = JSON.stringify({
                    "text": val
                });
                let axiosThis = this;

                let config = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    url: 'https://v3.mynt.in/mf/mfsearch',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: data
                };

                axios.request(config)
                    .then((response) => {
                        console.log(JSON.stringify(response.data));
                        if (response.data.data && response.data != []) {
                           var showdata = response.data.data;
for (let w = 0; w < showdata.length; w++) {
  let arr = showdata[w].Scheme_Name.split("-");

  // Default
  let type = "NORMAL";

  if (arr.some(a => a.includes("GROWTH"))) type = "GROWTH";
  else if (arr.some(a => a.includes("IDCW PAYOUT"))) type = "IDCW PAYOUT";
  else if (arr.some(a => a.includes("IDCW REINVESTMENT"))) type = "IDCW REINVESTMENT";
  else if (arr.some(a => a.includes("IDCW"))) type = "IDCW";

  showdata[w]["splito"] = type;
  showdata[w]["splitt"] = showdata[w].Scheme_Type.toUpperCase();
}

axiosThis.mf_data = showdata;
console.log("axiosThis.mf_data", axiosThis.mf_data);

                            axiosThis.mflistloader = false;
                            axiosThis.disabledmf = false;
                            console.log(axiosThis.mf_data);
                        } else {
                            axiosThis.mflistloader = false;
                            axiosThis.disabledmf = true;
                            axiosThis.Errorplaceholder = 'Funds not available';
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },

        displaybanner(v) {
            if (v == '/pms' || v == '/ipo' || v == '/mutualfunds' || v == '/insurance' || v == '/aif' || v == '/partner') {
                console.log("condii if", this.bannercondition);
                this.appdialog = false;
            } else {
                console.log("condii else", this.bannercondition);
                this.appdialog = true;
            }
        },
        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
    },
    computed: {
        dateRangeText() {
            return this.dates.join(" ~ ");
        },
        mf_dateformatted() {
            return this.formatDate(this.mf_date);
        },
        creatManmffrom() {
            return this.formatDate(this.creatManmffrommodel);
        },

        creatManmfto() {
            return this.formatDate(this.creatManmftomodel);
        },

        changefieldType(text) {
            return Number(text);
        },

        upiIDerrors() {
            const errors = [];
            if (this.upiidfield) {
                errors.push("You have entered the invalid UPI ID");
            }
            return errors;
        },
    },
};
</script>
